module.exports = __webpack_public_path__ + "assets/img/1_1715.634c7355.jpg";